import { Component } from '@angular/core';
import { DebugService } from '../../../public-api';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'lib-enabledebug',
    imports: [],
    templateUrl: './enabledebug.component.html',
    styles: []
})
export class EnabledebugComponent {

  // component to enable/disable debug mode

  constructor(
    private router: Router,
    private debug: DebugService
  ) {}

  ngOnInit() {
    if(this.debug.isDebugMode) {
      this.debug.setDebugMode(0);
    }
    else {
      this.debug.setDebugMode(1);
    }
    this.router.navigate(['/']);
  }
  
}
